import { render, staticRenderFns } from "./template.vue?vue&type=template&id=aae96ef8&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=aae96ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../agent-app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae96ef8",
  null
  
)

export default component.exports